module.exports = __webpack_public_path__ + "static/media/Headshot-Aidan.445d4b97.jpeg";